<script setup>
// BonBoZ: chip chủ đề. Dùng ở danh sách mẫu trong Cài đặt và ở bảng chọn mẫu
// dưới khung soạn tin — một chỗ để sau này đổi hình dáng cho cả hai.
import { computed } from 'vue';
import { chuDeTheoId, mauChip } from 'dashboard/helper/bonboz/chuDeMau';

const props = defineProps({
  id: { type: [Number, String], default: null },
  // Truyen thang khi da co san object (man quan ly chu de).
  chuDe: { type: Object, default: null },
});

const cd = computed(() => props.chuDe || chuDeTheoId(props.id));
</script>

<!-- eslint-disable-next-line vue/no-root-v-if -->
<template>
  <span
    v-if="cd"
    class="inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-xs font-medium max-w-[10rem]"
    :style="mauChip(cd.mau)"
  >
    <span
      class="rounded-full size-1.5 shrink-0"
      :style="{ backgroundColor: cd.mau }"
    />
    <span class="truncate">{{ cd.ten }}</span>
  </span>
</template>
